import React from "react";
import "./LegalMentions.css";
import Contact from "../../sections/Contact/Contact";
import { Helmet } from "react-helmet";

function LegalMentions() {
  return (
    <div>
      <Helmet>
        <title>Mentions Légales | Pokélu</title>
        <meta name="description" key="description" content="Mentions Légales" />
      </Helmet>
      <div className="legal-mentions">
        <h1>Mentions Légales</h1>

        <section>
          <h2>1. Éditeur du Site</h2>
          <p>
            Nom de la société : Pokélu <br />
            Adresse : 42 rue des Aulnays 72700 SPAY <br />
            Téléphone : +33 6 15 90 56 61 <br />
            Email : pokelu.educ@gmail.com <br />
            Numéro de siret : 97800617900029 <br />
          </p>
        </section>

        <section>
          <h2>2. Hébergement</h2>
          <p>
            Hébergeur : Firebase <br />
            Adresse : 1600 Amphitheatre Parkway, Mountain View, California
            94043, USA <br />
            Téléphone : Non disponible <br />
            Site web :{" "}
            <a
              href="https://firebase.google.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.firebase.google.com
            </a>
          </p>
        </section>

        <section>
          <h2>3. Propriété Intellectuelle</h2>
          <p>
            Le site et chacun des éléments qui le composent, incluant mais non
            limité aux textes, images, logos, etc., sont la propriété exclusive
            de Pokélu. Certaines images utilisées sur ce site proviennent de
            sources libres de droits, telles que Canva, mais toutes les images
            ne sont pas libres de droits. Toute reproduction, distribution,
            modification ou utilisation de ces éléments sans autorisation
            préalable est interdite.
          </p>
        </section>

        <section>
          <h2>4. Responsabilité</h2>
          <p>
            Pokélu ne saurait être tenu responsable pour tout dommage direct ou
            indirect résultant de l'accès ou de l'utilisation de ce site,
            incluant l'inaccessibilité, les pertes de données, les
            détériorations ou virus pouvant affecter l'équipement informatique
            de l'utilisateur.
          </p>
        </section>

        <section>
          <h2>5. Protection des Données Personnelles</h2>
          <p>
            Les informations recueillies sur ce site font l’objet d’un
            traitement informatique destiné au traitement des demandes de
            contact. Conformément à la loi « Informatique et Libertés », vous
            disposez d’un droit d’accès, de rectification et de suppression des
            informations vous concernant.
          </p>
        </section>

        <section>
          <h2>6. Cookies</h2>
          <p>
            Ce site utilise des cookies pour améliorer l’expérience utilisateur.
            Vous pouvez choisir de désactiver les cookies dans les paramètres de
            votre navigateur.
          </p>
        </section>
      </div>
      <Contact />
    </div>
  );
}

export default LegalMentions;
